import {useEffect} from "react";

const findFieldLabel = (field, form) => {
  if (field.labels?.length) return field.labels[0];

  if (field.id) {
    const linkedLabel = Array.from(form.querySelectorAll("label")).find(
      (label) => label.htmlFor === field.id,
    );
    if (linkedLabel) return linkedLabel;
  }

  let container = field.parentElement;
  while (container && container !== form) {
    const directLabel = Array.from(container.children).find(
      (child) => child.tagName === "LABEL",
    );
    if (directLabel) return directLabel;
    container = container.parentElement;
  }

  return null;
};

const RequiredFieldIndicators = () => {
  useEffect(() => {
    const refreshIndicators = () => {
      document
        .querySelectorAll("label[data-auto-required-indicator='true']")
        .forEach((label) => {
          label.classList.remove("required-field-label");
          delete label.dataset.autoRequiredIndicator;
        });

      document.querySelectorAll("form").forEach((form) => {
        form
          .querySelectorAll(
            "input[required], select[required], textarea[required], input[aria-required='true'], select[aria-required='true'], textarea[aria-required='true']",
          )
          .forEach((field) => {
            if (field.type === "hidden") return;
            const label = findFieldLabel(field, form);
            if (!label) return;
            label.classList.add("required-field-label");
            label.dataset.autoRequiredIndicator = "true";
          });
      });
    };

    refreshIndicators();
    const observer = new MutationObserver(refreshIndicators);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["required", "aria-required"],
    });

    return () => observer.disconnect();
  }, []);

  return null;
};

export default RequiredFieldIndicators;
